var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1737_7117)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.0605,
    r: 32,
    fill: "white",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.0605,
    r: 31.5,
    stroke: "white",
    strokeOpacity: 0.08
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1737_7117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 36.0605V35.0605H30C22.821 35.0605 17 29.2395 17 22.0605C17 21.5066 17.446 21.0605 18 21.0605H20C27.179 21.0605 33 26.8816 33 34.0605V36.0605V46.0605C33 46.6145 32.554 47.0605 32 47.0605C31.446 47.0605 31 46.6145 31 46.0605V36.0605ZM47 18.0605C47 24.3189 42.575 29.5479 36.686 30.7813C36.1222 27.8975 34.8318 25.2751 33.0129 23.1152C35.3168 19.4764 39.3774 17.0605 44 17.0605H46C46.554 17.0605 47 17.5066 47 18.0605Z",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1737_7117",
    x: -3.6,
    y: -3.53945,
    width: 71.2,
    height: 71.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1737_7117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1737_7117",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1737_7117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16.0605)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteGrowth);
export default __webpack_public_path__ + "static/media/white_growth.370769797c6ae4ff326c6ee6b4556147.svg";
export { ForwardRef as ReactComponent };